module.exports = __webpack_public_path__ + "static/media/galerija_2022_0028.be02aa58.jpg";